import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useFormContext } from 'react-hook-form';
import { formatSpacedNumber } from '../../../../../../../../utils/format';
import { CoApplicantDebtData } from '../../../../../../FormData.fi.types';
import { radioOptions } from '../../../../../config/globals';
import { gridColumns } from '../../../../../config/layouts/grid';
import { creditCardDebtOutstandingAmountFieldOption } from './config';

export const CreditCardDebt = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const hasCreditCardDebt = watch('Frontend/HasCreditCardDebt') === 'Yes';

  return (
    <Grid columns={gridColumns}>
      <RadioFieldUI<CoApplicantDebtData>
        name="Frontend/HasCreditCardDebt"
        label={t('CoApplicantDebt.CreditCard.question')}
        data-testid="has-credit-card-debt-input"
        options={radioOptions}
        radioStyle="both"
      />

      {hasCreditCardDebt && (
        <NumberFieldUI<CoApplicantDebtData>
          name="CoDebt/CreditCard/OutstandingAmount"
          label={t('CoApplicantDebt.CreditCard.OutstandingAmount.label')}
          data-testid="debt-credit-card-outstanding-amount-input"
          format={formatSpacedNumber}
          suffix={t('suffix.currency')}
          {...creditCardDebtOutstandingAmountFieldOption}
        />
      )}
    </Grid>
  );
};
